import ButtonPrimary from 'components/ButtonPrimary'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { getPremiumYearlyUrlRouteUtil } from 'modules/training/modules/subscription/utils/get-premium-yearly-url/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { hasFreeTrialEndedUserSelect } from 'modules/training/modules/training-users/selectors/has-free-trial-ended/index.js'
import { getSelectedSubscriptionPlanSelect } from 'modules/training/modules/training-premium/selectors/get-selected-subscription-plan/index.js'
import { isPremiumSubscriptionUserUtil } from 'modules/training/modules/training-users/utils/is-premium-subscription/index.js'
import { getPathnameWithQueryLocationUtil } from 'modules/router/utils/get-pathname-with-query/index.js'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'

const ANALYTIC_EVENT_LABEL = {
  TRY_PREMIUM_FREE: 'TRY_PREMIUM_FREE'
}

const messages = defineMessages({
  tryPremiumFree: {
    id: 'TryPremiumFreeButton.tryPremiumFree',
    defaultMessage: 'START FREE TRIAL ⭐️'
  },
  getPremium: {
    id: 'TryPremiumFreeButton.getPremium',
    defaultMessage: 'Get Premium ⭐️'
  },
  viewPremium: {
    id: 'TryPremiumFreeButton.viewPremium',
    defaultMessage: 'Get Premium ⭐️'
  }
})

export function TryPremiumFreeButton (props) {
  const intl = useIntl()

  const handleClickGetPremium = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT_LABEL.TRY_PREMIUM_FREE)
  }

  const hasFreeTrialEnded = useSelector(hasFreeTrialEndedUserSelect)
  const selectedSubscriptionPlan = useSelector(getSelectedSubscriptionPlanSelect)
  const hasPremium = useSelector(hasPremiumUserSelect)

  let url
  if (isPremiumSubscriptionUserUtil(selectedSubscriptionPlan)) {
    url = getPathnameWithQueryLocationUtil()
  } else {
    url = `${getPremiumYearlyUrlRouteUtil()}&openLogin=true`
  }

  let message
  if (hasPremium) {
    message = messages.viewPremium
  } else if (hasFreeTrialEnded) {
    message = messages.getPremium
  } else {
    message = messages.tryPremiumFree
  }

  return (
    <View {...props}>
      <ButtonPrimary
        onClick={handleClickGetPremium}
        url={url}
        style={{
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {formatMessageIntlUtil(intl, message)}
      </ButtonPrimary>
    </View>
  )
}
